import paths from "./paths";

export const TOP_NAV = [
  { id: "home", label: "Home", to: paths.pmDashboard, badge: null },
  { id: "dashboard", label: "Dashboard", to: paths.dashboard, badge: null },
  { id: "projects",  label: "Projects",  to: paths.projects,    badge: null },
  { id: "incidents", label: "Incidents", to: paths.incidents, badge: null },
  { id: "tickets", label: "Tickets", to: paths.tickets, badge: null },
  { id: "troubleshooting-guides", label: "TSGs", to: paths.troubleshootingGuides, badge: null },
  { id: "docs", label: "Docs", to: paths.docs, badge: null },
  { id: "tags",         label: "Tags",            to: paths.tags,       badge: null },
  { id: "qa-test-runs", label: "Testing & Validation", to: paths.qaTestRuns, badge: null },
  { id: "chat-space", label: "Chat Space", to: paths.chatSpace, badge: null },
  { id: "email-messages", label: "Email", to: paths.emailMessages, badge: null },
];

export const BOTTOM_NAV = [
  { id: "workspaces", label: "Workspaces", to: paths.workspaces, badge: null },
  { id: "partners", label: "Partnerships", to: paths.partners, badge: null },
  { id: "settings", label: "Settings", to: paths.settings, badge: null },
  { id: "access-control", label: "Access Control", to: paths.accessControl, badge: null },
  { id: "feedback", label: "Feedback", to: paths.feedback, badge: null },
  { id: "support", label: "Support", to: paths.support, badge: null },
  { id: "help", label: "Help", to: paths.help, badge: null },
];

export const FOOTER_NAV = [
  { id: "settings", label: "Settings",    to: paths.settings },
  { id: "help",     label: "Help & docs", to: paths.docs },
];
